export const EducationLevelEnum = Object.freeze({
  MiddleSchool: 0,
  HighSchool: 1,
  GED: 2,
  SomeCollegeNoDegree: 3,
  AssociateDegree: 4,
  TechnicalCertificate: 5,
  BachelorsDegree: 6,
  PostBaccalaureateCertificate: 7,
  MastersDegree: 8,
  ProfessionalDegree: 9,
  DoctoralDegree: 10,
});

export const EducationLevelLabel = Object.freeze({
  [EducationLevelEnum.MiddleSchool]: "Middle School (Grades 6-8)",
  [EducationLevelEnum.HighSchool]: "High School (Grades 9-12)",
  [EducationLevelEnum.GED]: "GED (High School Equivalency)",
  [EducationLevelEnum.SomeCollegeNoDegree]: "Some College, No Degree",
  [EducationLevelEnum.AssociateDegree]: "Associate Degree (AA / AS)",
  [EducationLevelEnum.TechnicalCertificate]: "Technical / Trade Certificate",
  [EducationLevelEnum.BachelorsDegree]: "Bachelor's Degree (BA / BS)",
  [EducationLevelEnum.PostBaccalaureateCertificate]: "Post-Baccalaureate Certificate",
  [EducationLevelEnum.MastersDegree]: "Master's Degree (MA / MS / MBA)",
  [EducationLevelEnum.ProfessionalDegree]: "Professional Degree (JD / MD / PharmD)",
  [EducationLevelEnum.DoctoralDegree]: "Doctoral Degree (PhD / EdD)",
});


// Helper to get list
export const getEducationLevelList = () =>
  Object.values(EducationLevelEnum).map((value) => ({
    value,
    label: EducationLevelLabel[value],
  }));
